
import axios from 'axios';



class CategoryService {
    categories(params) {
        return axios.get("/api/category", {
            params: params
        })
    }

    categoriesCount(params) {
        return axios.get("/api/category/count", {
            params: params
        })
    }

    categoryRegister(payload) {
        return axios.post("/api/category/register", payload)
    }

    categoryUpdate({id, name}) {
        return axios.post(`/api/category/update/${id}`, {
            name: name,
        })
    }
}


const categoryService = new CategoryService()

export default categoryService;